import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import {SeparatorType} from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import {Translate} from "@components/Theme/Translate/Translate"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	CategoryModuleType,
	CustomerStoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Link from "next/link"
import React from "react"

import CardsCategoryButton from "../CardsCategoryButton/CardsCategoryButton"

import styles from "./CustomerStoryHorizontal.module.scss"

type Props = {
	data: CustomerStoryModuleType
	container?: SeparatorType
	className?: string
}

const CustomerStoryHorizontal = (props: Props) => {
	const cardContainer = `${styles.cardContainer} ${props.className}`

	const preview = props.data.preview.filename
		? props.data.preview
		: props.data.logo
	return (
		<Link
			className={cardContainer}
			data-testid={"CustomerStoryHorizontalContainer"}
			href={props.data.link}
			rel={"noreferrer"}
		>
			<div className={styles.assetContainer}>
				<NewResponsiveImage
					{...preview}
					containerClassName={styles.imageContainer}
					imageClassName={styles.image}
					alt={props.data.title ?? preview?.alt}
				/>
			</div>

			<div className={styles.contentContainer}>
				<div className={styles.upperTitle}>
					<Typography
						as={"h5"}
						content={props.data.company}
						fontWeight={300}
						size={Size.M}
						// noPadding
					/>

					<Typography
						content={
							<>
								{props.data.useCase.map(
									(
										element: CategoryModuleType,
										index: number,
									) => {
										return (
											<CardsCategoryButton
												key={index}
												data={element}
												link={"customerStories"}
												modifier={"useCases"}
												typograpyProps={{
													fontWeight: 300,
													style: {
														textTransform:
															"uppercase",
													},
												}}
											/>
										)
									},
								)}
							</>
						}
						fontWeight={300}
						size={Size.S}
						variant={Variant.Description}
						noPadding
					/>
				</div>
				{/* <Separator size={32} /> */}
				<Typography
					as={"h4"}
					content={props.data.title}
					fontWeight={600}
					size={Size.M}
					variant={Variant.Title}
					noPadding
				/>
				<div className={styles.bigDesc}>
					<Typography
						content={props.data.content}
						size={Size.XS}
						truncate={200}
						variant={Variant.Description}
						noPadding
						stripHtml
					/>
					<object>
						<ButtonComponent
							buttonType={"readMore"}
							style={{
								marginTop: "2rem",
							}}
							asLink
						>
							<Translate> Read More</Translate>
						</ButtonComponent>
					</object>
				</div>
			</div>
			<div className={styles.smallDesc}>
				<Typography
					content={props.data.content}
					size={Size.XS}
					truncate={200}
					variant={Variant.Description}
					noPadding
					stripHtml
				/>
				<object>
					<ButtonComponent
						buttonType={"readMore"}
						style={{
							marginTop: "2rem",
						}}
						asLink
					>
						<Translate>Read More</Translate>
					</ButtonComponent>
				</object>
			</div>
		</Link>
	)
}

export default CustomerStoryHorizontal
